<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/UTxOTs/tc-custom/9781398433502.jpg?1705688300456" alt="This image is the cover for the book After the Applause"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">After the Applause
      </h1>
      <p class="bookDescription body article font2">
        <p>'Blurb' Contained within, Poetic words, some grim, of my recent experiences, during these times mysterious, of love and loyalty, and life’s’ great frailties, words of understanding, and observations on society, I share all this with you, humor, tears, happiness, fears, nakedly I bear my soul, for you to read, because we all need to forgive ourselves in times like these.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Andrew Ridgway
      </h2>
      
      <p class="authorDescription body article">Once upon a time Andrew Ridgway, who was born in 1973 wanted to be a writer. But life had other ideas, and so for over 21 years he has worked as a theater nurse.<br>In his first published book, which collects together his humanistic themed poetry Andrew is processing difficult events in his life. These include recent experiences being re-deployed to his hospital’s intensive care unit during the Covid 19 pandemic. <br>He is currently working on a second book of poetry based on love and relationships.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?bbbe0b16